<template>
  <div class="schedule">
    <div class="schedule__date-container">
      <div class="schedule__datepicker-box">
        <DatePicker
          required
          label="Escolha a data"
          :changeDate="changeDate"
          :dates="technicalDate"
        />
      </div>
      <div class="schedule__hours-picker-box">
        <HoursPicker
          label="Escolha um horario"
          :options="getHours"
          :changeHour="changeHour"
        />
      </div>
    </div>
    <div class="schedule__error">{{ error }}</div>
    <div class="schedule__btn-box">
      <v-btn @click="goToHome" color="normal"> Cancelar </v-btn>
      <v-btn @click="sendReschedule" color="success" :loading="loader">
        Reagendar
      </v-btn>
    </div>
  </div>
</template>

<script>
import DatePicker from '@/components/fields/DatePicker';
import HoursPicker from '@/components/fields/HoursPicker';
import bus from '@/utils/bus';
import enums from '@/utils/enums';
import { CONFIG, TICKET_CRM } from '@/utils/constants';
import logTrace from '@/services/logTrace';
import { contractIsActive } from '../../../../utils';

export default {
  components: {
    DatePicker,
    HoursPicker,
  },
  data() {
    return {
      technicalSchedule: [],
      technicalDate: [],
      selectedDate: new Date().toISOString().substr(0, 10),
      scheduleSelected: undefined,
      ticketId: decodeURIComponent(this.$router.currentRoute.params.ticketId),
      loader: false,
      error: '',
    };
  },
  methods: {
    async getDates() {
      let productId = this.selectedUnit.product.id;
      let blockCode = this.selectedUnit.block.code;
      const kitfixUrl = this.$store.getters[CONFIG.GET_KITFIX_URL];
      let url = `${kitfixUrl}/api/schedule/getSchedulesByProduct`;
      let params = {
        productId,
        productBlockCode: blockCode,
      };
      let response = await this.requestService(url, 'GET', { params });
      this.technicalSchedule = response;
      this.technicalDate = response.map((item) => {
        let [localDate, localHour] = item.startDateLocalTime.split('T');
        return {
          value: item.id,
          date: localDate,
          hour: localHour,
          available: !item.isScheduled,
        };
      });
    },
    changeDate(val) {
      this.selectedDate = val;
    },
    changeHour(val) {
      this.selectedHour = val;
      let selected = this.getSchedule(val.value);
      this.scheduleSelected = selected;
      this.error = '';
    },
    getSchedule(id) {
      return this.technicalSchedule.find((item) => item.id === id);
    },
    goToHome() {
      this.$router.push({ name: 'home' });
    },
    async sendReschedule() {
      if (!this.scheduleSelected) {
        this.error = 'Selecione um horário';
      } else {
        this.rescheduleRequest();
      }
    },
    async rescheduleRequest() {
      this.loader = true;
      let idSchedule = this.scheduleSelected.id;
      const kitfixUrl = this.$store.getters[CONFIG.GET_KITFIX_URL];
      let url = `${kitfixUrl}/api/workOrder/rescheduleWorkOrders`; //?idTicket=${this.ticketId}&idSchedule=${idSchedule}
      const body = {
        schedule: this.scheduleSelected,
        idTicket: this.ticketId,
      };
      const response = await this.requestService(url, 'PUT', { data: body });
      if (!response) {
        bus.$emit('snackbar:open', {
          text: ' Ocorreu um erro, por favor tente novamente mais tarde. ',
          color: enums.snackbarColors.error,
        });
      } else {
        if (response.length > 0) {
          const contractId =
            this.selectedUnit.contracts.find(contractIsActive).id;
          const ticketNumber = response[0].ticketNumber;
          let smsUrl = `${process.env.SMS_API}/addToQueue`;
          const smsData = {
            contractId,
            productId: this.selectedUnit.product.id,
            blockCode: this.selectedUnit.block.code,
            unitCode: this.selectedUnit.unit.code,
            smsType: 'technicalAssistanceScheduled',
            ticketNumber: ticketNumber,
            ticketCrmToken: this.$store.getters[TICKET_CRM.GET_TOKEN],
          };
          this.requestService(smsUrl, 'POST', { data: smsData });
        }
        bus.$emit('snackbar:open', {
          text: 'Agendamento com sucesso',
          color: enums.snackbarColors.success,
        });
        logTrace({
          action: this.enums.logTraceActions.technicalAssistanceReschedule,
          details: {
            newDate: this.scheduleSelected.startDateLocalTime,
            ticketId: this.ticketId,
          },
        });
        this.$router.push({ name: 'home' });
      }
      this.loader = false;
    },
  },
  created() {
    this.getDates();
  },
  computed: {
    getHours() {
      return this.technicalDate.filter(
        (item) => item.date === this.selectedDate
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.schedule {
  &__date-container {
    display: flex;
    justify-content: space-between;
    align-content: center;
  }
  &__datepicker-box {
    display: flex;
    align-content: center;
  }
  &__hours-picker-box {
    display: flex;
  }

  &__btn-box {
    display: flex;
    justify-content: center;
  }

  &__error {
    text-align: center;
    margin-bottom: 1rem;
    color: red;
  }
}

.required {
  color: red;
  margin: 0 8px;
}
</style>



// WEBPACK FOOTER //
// ./src/views/support/ticket/technicalAssistance/RescheduleTicket.vue